const strings = {
  START_TIME: 'Starttid',
  END_TIME: 'Sluttid',
  NEW_USER: 'Ny användare',
  NEW_USER_INFO:
    'Vill du ladda ner manualen och ge den till den nya användaren eller skapa kontot själv?',
  CREATE_NEW_USER: 'Skapa själv',
  CANCEL: 'Avbryt',
  DELETE_LAUNDRY_TIME: 'Ta bort tvättid',
  DELETE_LAUNDRY_TIME_INFO:
    'Är du säker på att du vill ta bort tvättiden? Detta kan inte göras ogjort.',
  YES: 'Ja',
  NO: 'Nej',
  MANAGE_GENERAL_SETTINGS: 'Hantera allmänna inställningar',
  LAUDRY_TYPE: 'Tvättstugor eller tvättmaskiner?',
  BOOKING_RANGE: 'Framtidsbokning',
  MAX_BOOKINGS: 'Max antal bokningar',
  LAUNDRIES: {
    S: 'Tvättstugor',
    M: 'Tvättmaskiner'
  },
  NO_LIMIT: 'Ingen gräns',
  LAUNDRY_TIME_AT_A_TIME: 'tvättid åt gången',
  LAUNDRY_TIMES_AT_A_TIME: 'tvättider åt gången',
  WEEKS: 'veckor',
  WEEK: 'vecka'
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/LaundryRulesTable/strings.js